import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "redux/axiosInterceptor";

const API_URL = process.env.REACT_APP_BASE_URL;


export const fetchAsyncGetPONumPurchaseOrder = createAsyncThunk(
    "/fetchAsyncGetPONumPurchaseOrder",
    async (data) => {
      try {
        let url = `${API_URL}/purchase/getPoNum`;
        const response = await axiosInstance.post(url,data);
        return response.data;
      } catch (error) {
        throw new Error(error.response.data.message);
      }
    }
  );

  export const fetchAsyncSendRequestApprovalPurchaseOrderPayAmount = createAsyncThunk(
    "/fetchAsyncSendRequestApprovalPurchaseOrderPayAmount",
    async (data) => {
      try {
        let url = `${API_URL}/purchase/send-request-approve-total-pay-amount`;
        const response = await axiosInstance.post(url, data);
       
        return response.data;
      } catch (error) {
        throw new Error(error.response.data.message);
      }
    }
  );

  export const fetchAsyncUpdatePurchaseOrder = createAsyncThunk(
    "/fetchAsyncUpdatePurchaseOrder",
    async (data) => {
      try {
        const response = await axiosInstance.put(`${API_URL}/purchase/update/${data.id}`,data.data);
        return response.data;
      } catch (error) {
        throw new Error(error.response.data.message);
      }
    }
  );
  export const fetchAsyncSendRequestUpdateApprovalPurchaseOrderTotalPayAmount = createAsyncThunk(
    "/fetchAsyncSendRequestUpdateApprovalPurchaseOrderTotalPayAmount",
    async (data) => {
      try {
        let url = `${API_URL}/purchase/send-request-update-approve-total-pay-amount/${data.id}`;
        const response = await axiosInstance.put(url, data.data);
  
        return response.data;
      } catch (error) {
        throw new Error(error.response.data.message);
      }
    }
  );

  export const fetchAsyncRejectPurchaseOrderTotalPayAmount = createAsyncThunk(
    "/fetchAsyncRejectPurchaseOrderTotalPayAmount",
    async (data) => {
      try {
        let url = `${API_URL}/purchase/reject-total-pay-amount/${data.id}`;
        const response = await axiosInstance.put(url, data.data);
  
        return response.data;
      } catch (error) {
        throw new Error(error.response.data.message);
      }
    }
  );

  export const fetchAsyncApprovePurchaseOrderTotalPayAmount = createAsyncThunk(
    "/fetchAsyncApprovePurchaseOrderTotalPayAmount",
    async (data) => {
      try {
        let url = `${API_URL}/purchase/approve-total-pay-amount/${data.id}`;
        const response = await axiosInstance.put(url, data.data);
  
        return response.data;
      } catch (error) {
        throw new Error(error.response.data.message);
      }
    }
  );
  
  
  export const fetchAsyncDeletePurchaseOrder = createAsyncThunk(
    "/fetchAsyncDeletePurchaseOrder",
    async (id) => {
      try {
        let url = `${API_URL}/purchase/delete/${id}`;
        const response = await axiosInstance.delete(url);
        return response.data;
      } catch (error) {
        throw new Error(error.response.data.message);
      }
    }
  );

export const fetchAsyncDeletePurchaseOrderPdf = createAsyncThunk(
  "/fetchAsyncDeletePurchaseOrderPdf",
  async (data) => {
    try {
      let url = `${API_URL}/purchase/delete_pdf/${data.id}`;
      const response = await axiosInstance.post(url,{ key: data.key,listIndex:data?.listIndex,spId:data?.spId });
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.msg);
    }
  }
);
export const fetchAsyncUploadPurchaseOrderPdf = createAsyncThunk(
  "/fetchAsyncUploadPurchaseOrderPdf",
  async (data) => {
    try {
      let url = `${API_URL}/purchase/upload_pdf/${data.id}`;
      const response = await axiosInstance.post(url,data.formData);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.msg);
    }
  }
);
export const fetchAsyncAddPurchaseOrderInvoiceRemark = createAsyncThunk(
  "/fetchAsyncAddPurchaseOrderInvoiceRemark",
  async (data) => {
    try {
      let url = `${API_URL}/purchase/invoice-remark/${data.id}`;
      const response = await axiosInstance.put(url, data.remarkData);

      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncDeletePurchaseOrderPaymentListItem = createAsyncThunk(
  "/fetchAsyncDeletePurchaseOrderPaymentListItem",
  async (data) => {
    try {
      let url = `${API_URL}/purchase/delete-purchase-order-payment-list-item/${data.id}`;
      const response = await axiosInstance.post( url,{listIndex:data?.listIndex });
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.msg);
    }
  }
);

export const fetchAsyncDeletePurchaseOrderRefundListItem = createAsyncThunk(
  "/fetchAsyncDeletePurchaseOrderRefundListItem",
  async (data) => {
    try {
      let url = `${API_URL}/purchase/delete-purchase-order-refund-list-item/${data.id}`;
      const response = await axiosInstance.post( url,{listIndex:data?.listIndex });
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.msg);
    }
  }
);

export const fetchAsyncHardDeletePurchaseOrder = createAsyncThunk(
  "/fetchAsyncHardDeletePurchaseOrder",
  async (id) => {
    try {
      let url = `${API_URL}/purchase/hard-delete/${id}`;
      const response = await axiosInstance.delete(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);